// extracted by mini-css-extract-plugin
module.exports = {"modal":"BAWorkAnswersModal_modal__QsQFu","content":"BAWorkAnswersModal_content__2q_I-"};